import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';
import {fromJson} from '../../core/data-source/json.mapper';
import {HttpService, httpService} from '../../core/services/http.service';
import {AddressRecord} from '../../records/address.record';
import {TerritoryRecord} from '../../records/territory.record';

export class TerritoryCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/scheduling-zones';

    updateOrder(aocId: number): Promise<any> {
        return httpService.get(this.apiPath + `/updateOrders/` + aocId);
    }

    async getForOrder(aocId: number, address: AddressRecord): Promise<TerritoryRecord> {
        return httpService
            .post(
                this.apiPath + '/getForOrder',
                HttpService.paramsToQuery({aocId: aocId, latitude: address?.latitude, longitude: address?.longitude}),
                {headers: HttpService.FORM_DATA_HEADERS}
            )
            .then((response: any) => {
                if (response.data.success) {
                    if (response.data.rows.length) {
                        return fromJson(TerritoryRecord, response.data.rows[0]);
                    }
                }
            });
    }
}
